import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import Breadcrumbs from '@mui/material/Breadcrumbs';

function FacultyEdit() {

    const [gettingData, setGettingdata] = useState(false)
    const [faculty, setFaculty] = useState(null)
    const [name, setName] = useState('')
    const [designation, setDesignation] = useState('')
    const [designation_rank, setDesignationRank] = useState(999)
    const [order_no, setOrderNo] = useState(999)

    const token = localStorage.getItem('token')
    let navigate = useNavigate()
    const { id } = useParams()

    useEffect(() => {
        setGettingdata(true)
        const getData = async () => {
            try {
                const response = await axios.get(process.env.REACT_APP_DEPT_API + '/faculty/' + id)
                setFaculty(response.data)
                setName(response.data.name)
                setDesignation(response.data.designation)
                setOrderNo(response.data.order_no)
                setDesignationRank(response.data.designation_rank)
                setGettingdata(false)
            } catch (err) {
                console.log(err)
                alert("Error, check console logs")
            }
        }
        getData()
        // eslint-disable-next-line
    }, [])


    const submitHandler = (e) => {
        if (name && designation && order_no) {
            e.preventDefault();
            let data = { name, designation, designation_rank, order_no }
            axios.put(`${process.env.REACT_APP_DEPT_API}/admin/auth/faculty/${id}/update`, data, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then(() => {
                alert("Updated sucessfully")
            }).then(() => {
                navigate('/admin/faculty/')
            }).catch(err => {
                alert(err.response.data.error)
                console.log(err)
            })
        } else {
            alert('Enter all the fields!')
        }
    }

    const ranks = {
        "Principal": 10,
        "HOD & Professor": 20,
        "Professor": 30,
        "Associate Professor": 40,
        "Assistant Professor (Sr Scale)": 45,
        "Assistant Professor": 50,
        "System Analyst": 60,
        "Jr. System Analyst": 65,
        "Foreman": 70,
        "Computer Programmer": 80,
        "Tradesman": 90
    }
    return (
        <div className='admin'>
            <div className='section__container'>
                <div className='section'>
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link to="/admin" className='breadcrumb__link'>
                            Admin
                        </Link>
                        <Link to="/admin/faculty" className='breadcrumb__link'>
                            Faculty   
                        </Link>
                        <Link to="" className='breadcrumb__link bold'>
                            Edit
                        </Link>
                    </Breadcrumbs>
                </div>
                {!gettingData ?
                    <div className='section'>
                        <h3 className='section__header'>Edit Faculty</h3>
                        <form onSubmit={submitHandler} className="admin_form_container">
                            <div className='admin_input_container'>
                                <label className='admin_label'>Name</label>
                                <input required className='admin_input' type="text" placeholder='Jane Doe' defaultValue={faculty ? faculty.name : ""} onChange={e => setName(e.target.value)} />
                            </div>
                            <div className='admin_input_container'>
                                <label className='admin_label'>Designation</label>
                                <select className='admin_input' defaultValue={faculty ? faculty.designation : ""} onChange={e => { setDesignation(e.target.value); setDesignationRank(Number(ranks[e.target.value])) }} required>
                                    <option value="" disabled>Select</option>
                                    <option value="Principal">Principal</option>
                                    <option value="HOD & Professor">HOD & Professor</option>
                                    <option value="Professor">Professor</option>
                                    <option value="Associate Professor">Associate Professor</option>
                                    <option value="Assistant Professor (Sr Scale)">Assistant Professor (Sr Scale)</option>
                                    <option value="Assistant Professor">Assistant Professor</option>
                                    <option value="System Analyst">System Analyst</option>
                                    <option value="Jr. System Analyst">Jr. System Analyst</option>
                                    <option value="Foreman">Foreman</option>
                                    <option value="Computer Programmer">Computer Programmer</option>
                                    <option value="Tradesman">Tradesman</option>
                                </select>
                            </div>
                            <div className='admin_input_container'>
                                <label className='admin_label'>Order_No</label>
                                <input required className='admin_input' type="number" defaultValue={faculty ? faculty.order_no : ""} onChange={e => setOrderNo(Number(e.target.value))} />
                            </div>
                            <p>Note: Faculty are automatically ordered based on designation. Decrease order_no to order within the selected Designation</p>
                            <button type="submit" className='admin_btn'>Submit</button>
                        </form>
                    </div>
                    : <p>Loading...</p>}
            </div>
        </div>
    )
}

export default FacultyEdit